import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import TextContentButtonGroup from './components/TextContentButtonGroup';

// variant = default | ImageAndContent | MultipleBlocks
const TextContent = t0 => {
  const $ = _c(55);
  const {
    config,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const {
    elementAttribute,
    imageComponent,
    backgroundSelection: t2,
    textContentSection: t3,
    buttonSection
  } = config;
  const {
    backgroundColor
  } = t2;
  const {
    textColor,
    textOrientation: textOrientationRaw,
    title: t4,
    body: t5
  } = t3;
  const {
    text: titleText,
    tag: titleTag,
    size: titleSize
  } = t4;
  const {
    text: bodyText,
    tag: bodyTag,
    size: bodySize
  } = t5;
  const layoutSize = imageComponent?.size ?? "Full Width";
  const TitleTag = titleTag ?? "h2";
  const BodyTag = bodyTag ?? "p";
  let t10;
  let t11;
  let t12;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== BodyTag || $[1] !== TitleTag || $[2] !== backgroundColor || $[3] !== bodySize || $[4] !== bodyText || $[5] !== buttonSection || $[6] !== elementAttribute?.id || $[7] !== layoutSize || $[8] !== textColor || $[9] !== textOrientationRaw || $[10] !== titleSize || $[11] !== titleText || $[12] !== variant) {
    const textOrientation = textOrientationRaw.toLowerCase().split(" ").join("-");
    const {
      isMultipleBtn: t13,
      button1,
      button2,
      button3,
      button4
    } = buttonSection;
    const isMultipleBtn = t13 === undefined ? false : t13;
    t12 = classNames("w-full flex justify-center", {
      "px-5 md:px-[3.333vw] min-[1500px]:px-[50px]": variant === "default" && layoutSize === "Full Page",
      "items-start": textOrientation.startsWith("top"),
      "items-center": textOrientation.startsWith("center") || textOrientation.startsWith("right") || textOrientation.startsWith("left"),
      "items-end": textOrientation.startsWith("bottom")
    });
    t6 = elementAttribute?.id ?? "";
    const t14 = variant === "default";
    const t15 = variant !== "default";
    const t16 = layoutSize === "Full Width" || variant === "ImageAndContent";
    const t17 = layoutSize === "Full Page" && variant !== "default";
    const t18 = layoutSize === "Full Page" && variant === "default";
    const t19 = textOrientation !== "right";
    const t20 = textOrientation === "left";
    const t21 = textOrientation === "right";
    const t22 = textOrientation === "top-left";
    const t23 = textOrientation === "top-right";
    const t24 = textOrientation === "top-center";
    const t25 = textOrientation === "bottom-left";
    const t26 = textOrientation === "bottom-right";
    const t27 = textOrientation === "bottom-center";
    const t28 = textOrientation === "center";
    const t29 = variant === "MultipleBlocks";
    if ($[20] !== t14 || $[21] !== t15 || $[22] !== t16 || $[23] !== t17 || $[24] !== t18 || $[25] !== t19 || $[26] !== t20 || $[27] !== t21 || $[28] !== t22 || $[29] !== t23 || $[30] !== t24 || $[31] !== t25 || $[32] !== t26 || $[33] !== t27 || $[34] !== t28 || $[35] !== t29) {
      t7 = classNames("text-gray md:mx-auto md:mb-0 md:text-center", {
        "mt-[30px] px-5 md:px-[3.333vw] min-[1500px]:px-[50px] py-5 md:py-[3.333vw] min-[1500px]:py-[50px]": t14,
        "px-0 py-0": t15,
        "w-full": t16,
        "max-w-[1400px]": t17,
        "w-full sm:w-[1400px]": t18,
        "!flex-row": t19,
        "content-start": t20,
        "flex-row-reverse": t21,
        "items-start": t22,
        "items-start flex-row-reverse": t23,
        "items-start justify-center": t24,
        "items-end": t25,
        "items-end flex-row-reverse": t26,
        "items-end justify-center": t27,
        "justify-center": t28,
        "pt-0": t29
      });
      $[20] = t14;
      $[21] = t15;
      $[22] = t16;
      $[23] = t17;
      $[24] = t18;
      $[25] = t19;
      $[26] = t20;
      $[27] = t21;
      $[28] = t22;
      $[29] = t23;
      $[30] = t24;
      $[31] = t25;
      $[32] = t26;
      $[33] = t27;
      $[34] = t28;
      $[35] = t29;
      $[36] = t7;
    } else {
      t7 = $[36];
    }
    const t30 = backgroundColor ?? "";
    if ($[37] !== t30) {
      t8 = {
        backgroundColor: t30
      };
      $[37] = t30;
      $[38] = t8;
    } else {
      t8 = $[38];
    }
    const t31 = textColor ?? "";
    let t32;
    if ($[39] !== t31) {
      t32 = {
        color: t31
      };
      $[39] = t31;
      $[40] = t32;
    } else {
      t32 = $[40];
    }
    t9 = <TitleTag className={classNames("text-3xl font-bold", {
      "text-3xl font-bold": titleSize === "text-3xl" && variant !== "MultipleBlocks",
      "text-2xl md:text-3xl font-bold": titleSize === "text-3xl" && variant === "MultipleBlocks",
      "text-[clamp(1.75rem,5.2vw,2.5rem)] leading-[clamp(2.25rem,6.25vw,3rem)] tracking-[.0125rem] font-bold": titleSize === "text-4xl",
      "text-xs": titleSize === "text-xs",
      "text-sm": titleSize === "text-sm",
      "text-base": titleSize === "text-base",
      "text-lg": titleSize === "text-lg",
      "text-xl": titleSize === "text-xl",
      "text-2xl": titleSize === "text-2xl",
      "text-center": textOrientation.endsWith("center"),
      "text-left": textOrientation.endsWith("left"),
      "text-right": textOrientation.endsWith("right"),
      "mb-5 md:mb-[30px]": !!bodyText
    })} style={t32}>{titleText}</TitleTag>;
    const t33 = textColor ?? "";
    let t34;
    if ($[41] !== t33) {
      t34 = {
        color: t33
      };
      $[41] = t33;
      $[42] = t34;
    } else {
      t34 = $[42];
    }
    let t35;
    if ($[43] !== bodyText) {
      t35 = !!bodyText && <div className="[&_ul]:list-disc [&_ol]:list-[auto] [&_ul]:list-inside [&_ol]:list-inside [&_ul]:pl-4 [&_ol]:pl-4" dangerouslySetInnerHTML={{
        __html: bodyText
      }} />;
      $[43] = bodyText;
      $[44] = t35;
    } else {
      t35 = $[44];
    }
    t10 = <BodyTag className={classNames("text-base [&_a]:font-bold", {
      "text-xs": bodySize === "text-xs",
      "text-sm": bodySize === "text-sm",
      "text-base": bodySize === "text-base",
      "text-lg": bodySize === "text-lg",
      "text-xl": bodySize === "text-xl",
      "text-2xl": bodySize === "text-2xl",
      "text-3xl": bodySize === "text-3xl",
      "text-center justify-items-center": textOrientation.endsWith("center"),
      "text-left justify-items-start": textOrientation.endsWith("left"),
      "text-right justify-items-end": textOrientation.endsWith("right")
    })} style={t34}>{t35}</BodyTag>;
    t11 = !!button1 && (button1.selected === "CTALink" ? button1?.ctaLink?.content?.trim() !== "" : button1.selected === "CTAButton" ? button1?.ctaButton?.content?.trim() !== "" : false) && <div className={classNames("flex flex-row items-center h-14", {
      "justify-center": textOrientation.endsWith("center"),
      "justify-start": textOrientation.endsWith("left"),
      "justify-end": textOrientation.endsWith("right"),
      "mt-4": variant !== "MultipleBlocks",
      "mt-0": variant === "MultipleBlocks"
    })}><TextContentButtonGroup mainButton={button1} subButton={button3} />{!!isMultipleBtn && !!button2 && <TextContentButtonGroup className="ml-4" mainButton={button2} subButton={button4} />}</div>;
    $[0] = BodyTag;
    $[1] = TitleTag;
    $[2] = backgroundColor;
    $[3] = bodySize;
    $[4] = bodyText;
    $[5] = buttonSection;
    $[6] = elementAttribute?.id;
    $[7] = layoutSize;
    $[8] = textColor;
    $[9] = textOrientationRaw;
    $[10] = titleSize;
    $[11] = titleText;
    $[12] = variant;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t13;
  if ($[45] !== t10 || $[46] !== t11 || $[47] !== t6 || $[48] !== t7 || $[49] !== t8 || $[50] !== t9) {
    t13 = <div id={t6} className={t7} style={t8}>{t9}{t10}{t11}</div>;
    $[45] = t10;
    $[46] = t11;
    $[47] = t6;
    $[48] = t7;
    $[49] = t8;
    $[50] = t9;
    $[51] = t13;
  } else {
    t13 = $[51];
  }
  let t14;
  if ($[52] !== t12 || $[53] !== t13) {
    t14 = <div className={t12}>{t13}</div>;
    $[52] = t12;
    $[53] = t13;
    $[54] = t14;
  } else {
    t14 = $[54];
  }
  return t14;
};
export default TextContent;